import { render, staticRenderFns } from "./_SerumCrossmatchSection.vue?vue&type=template&id=1c6800ac&"
import script from "./_SerumCrossmatchSection.vue?vue&type=script&lang=ts&"
export * from "./_SerumCrossmatchSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports